(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sw-hsa-products"] && !Shopify.designMode) return;
  try {
    
  class SwProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sw-track]');
      this.prev = this.querySelector('[data-sw-prev]');
      this.next = this.querySelector('[data-sw-next]');
      if (!this.track) return;

      this.onScroll = this.update.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      if (this.prev) this.prev.addEventListener('click', () => this.scrollByCard(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollByCard(1));

      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    get step() {
      const first = this.track.firstElementChild;
      if (!first) return this.track.clientWidth;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.track.scrollBy({ left: this.step * direction, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= max - 1;
      const overflows = max > 1;

      if (this.prev) this.prev.hidden = atStart || !overflows;
      if (this.next) this.next.hidden = atEnd || !overflows;
    }
  }

  if (!customElements.get('sw-product-carousel')) {
    customElements.define('sw-product-carousel', SwProductCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
